import type { JSX, ReactNode } from 'react';
import React from 'react';

import PrimaryNavV1 from './Page/PrimaryNav/V1';

import * as styles from './AppLayoutV1.css';

interface IAppLayoutProps {
  children: ReactNode;
}

function AppLayoutV1({ children }: Readonly<IAppLayoutProps>): JSX.Element {
  return (
    <div className={styles.root}>
      {children}
      <PrimaryNavV1 className={styles.sidebar} />
    </div>
  );
}

export default AppLayoutV1;
